import { UserPermissions } from "../models/UserPermissionModel";
import { http } from "./Http";

export const GetUserPermissions = (
  token: any,
  url: any
): Promise<UserPermissions> => {
  return http({ token: token, url: url });
};
